/* eslint-disable no-unused-vars */
import { mobiscroll } from '../core/core'; // mobiscroll needed for trial
/* eslint-enable no-unused-vars */
import { $, extend, Base, classes } from '../core/core';
import { isNumeric, noop } from '../util/misc';
import { triggerClick } from '../util/tap';
import { ScrollViewBase } from './scrollview-base';

var guid = 1;

export const ScrollView = function (elm, settings, inherit) {
    var $activeItem,
        $cont,
        $ctx,
        $wnd,
        contWidth,
        itemWidth,
        oldWidth,
        posDebounce,
        rtl,
        scrollView,
        snap,
        s,
        totalWidth,
        touched,
        trigger,
        cssClasses = {},
        animTime = 1000,
        that = this,
        $elm = $(elm);

    function onResize(ev) {
        clearTimeout(posDebounce);
        posDebounce = setTimeout(function () {
            size(ev.type !== 'load');
        }, 200);
    }

    function onItemTap($item, toggle) {
        if (!$item.length) {
            return;
        }

        toggle = that._onItemTap($item, toggle);

        $activeItem = $item;

        if ($item.parent()[0] == elm) {
            var bl = $item.offset().left,
                bp = $item[0].offsetLeft,
                bw = $item[0].offsetWidth,
                cl = $cont.offset().left;

            if (rtl) {
                bp = totalWidth - bp - bw;
            }
            // Scroll item to view
            if (s.variant == 'a') {
                if (bl < cl) {
                    scrollView.scroll(rtl ? bp + bw - contWidth : -bp, animTime, true);
                } else if (bl + bw > cl + contWidth) {
                    scrollView.scroll(rtl ? bp : contWidth - bp - bw, animTime, true);
                }
            } else {
                // Scroll item to center
                scrollView.scroll(contWidth / 2 - bp - bw / 2, animTime, true);
            }
        }

        if (toggle) {
            // Trigger tap event
            trigger('onItemTap', {
                target: $item[0]
            });
        }
    }

    function initMarkup() {
        var $firstItem,
            props;

        that._initMarkup($cont);

        $elm.find('.mbsc-ripple').remove();

        that._$items = $elm.children();
        that._$items.each(function (i) {
            var cssClass,
                $item = $(this),
                ref = $item.attr('data-ref');

            if (!ref) {
                ref = guid++;
            }

            if (i === 0) {
                $firstItem = $item;
            }

            if (!$activeItem) {
                $activeItem = that._getActiveItem($item);
            }

            props = that._getItemProps($item) || {};

            cssClass = 'mbsc-scv-item mbsc-btn-e ' +
                (props.cssClass || '');

            $item
                .attr('data-ref', ref)
                .removeClass(cssClasses[ref])
                .addClass(cssClass);

            cssClasses[ref] = cssClass;

            /* TRIAL */
        });

        if (!$activeItem) {
            $activeItem = $firstItem;
        }

        that._markupReady($cont);
    }

    function size(check, noScroll) {
        var w = s.itemWidth,
            layout = s.layout;

        that.contWidth = contWidth = $cont.width();

        if ((check && oldWidth === contWidth) || !contWidth) {
            // Don't do anything if container width has not changed
            return;
        }

        oldWidth = contWidth;

        if (isNumeric(layout)) {
            itemWidth = contWidth ? contWidth / layout : w;

            if (itemWidth < w) {
                layout = 'liquid';
            }
        }

        if (w) {
            if (layout == 'liquid') {
                // The specified itemWidth will be handled as min width
                itemWidth = contWidth ? contWidth / Math.min(Math.floor(contWidth / w), that._$items.length) : w;
            } else if (layout == 'fixed') {
                // Fixed width
                itemWidth = w;
            }
        }

        that._size(contWidth, itemWidth);

        if (itemWidth) {
            $elm.children().css('width', itemWidth + 'px');
        }

        that.totalWidth = totalWidth = elm.offsetWidth;

        extend(scrollView.settings, {
            contSize: contWidth,
            maxSnapScroll: s.paging ? 1 : false,
            maxScroll: 0,
            minScroll: totalWidth > contWidth ? contWidth - totalWidth : 0,
            snap: s.paging ? contWidth : (snap ? itemWidth || '.mbsc-scv-item' : false),
            elastic: totalWidth > contWidth ? itemWidth || contWidth : false
        });

        // Pass new values to scrollview
        scrollView.refresh(noScroll);
    }

    // Call the parent constructor
    Base.call(this, elm, settings, true);

    that.navigate = function ($item, toggle) {
        onItemTap(that._getItem($item), toggle);
    };

    that.next = function (toggle) {
        if ($activeItem) {
            var $next = $activeItem.next();
            if ($next.length) {
                $activeItem = $next;
                onItemTap($activeItem, toggle);
            }
        }
    };

    that.prev = function (toggle) {
        if ($activeItem) {
            var $prev = $activeItem.prev();
            if ($prev.length) {
                $activeItem = $prev;
                onItemTap($activeItem, toggle);
            }
        }
    };

    /**
     * Recalculates sizes.
     */
    that.refresh = that.position = function (noScroll) {
        initMarkup();
        size(false, noScroll);
    };

    /**
     * Initialization.
     */
    that._init = function () {
        var contClass;

        $ctx = $(s.context);
        $wnd = $(s.context == 'body' ? window : s.context);

        that.__init();

        rtl = s.rtl;
        snap = (s.itemWidth && s.snap === undefined) ? true : s.snap;
        contClass = 'mbsc-scv-c mbsc-no-touch' + ' mbsc-' + s.theme + ' ' +
            (s.cssClass || '') + ' ' +
            (s.wrapperClass || '') +
            (s.baseTheme ? ' mbsc-' + s.baseTheme : '') +
            (rtl ? ' mbsc-rtl' : ' mbsc-ltr') +
            (s.itemWidth ? ' mbsc-scv-hasw' : '') +
            (s.context == 'body' ? '' : ' mbsc-scv-ctx') + ' ' +
            (that._getContClass() || '');

        if (!$cont) {
            $cont = $('<div class="' + contClass + '"><div class="mbsc-scv-sc"></div></div>')
                .insertAfter($elm);

            $cont
                .find('.mbsc-scv-sc')
                .append($elm);

            scrollView = new ScrollViewBase($cont[0], {
                axis: 'X',
                contSize: 0,
                maxScroll: 0,
                maxSnapScroll: 1,
                minScroll: 0,
                snap: 1,
                elastic: 1,
                rtl: rtl,
                mousewheel: s.mousewheel,
                thresholdX: s.threshold,
                stopProp: s.stopProp,
                onStart: function (ev) {
                    if (!touched && ev.domEvent.type == 'touchstart') {
                        touched = true;
                        $ctx.find('.mbsc-no-touch').removeClass('mbsc-no-touch');
                    }
                },
                onBtnTap: function (ev) {
                    // Prevent phantom click and trigger synthetic click
                    if (ev.domEvent.type === 'touchend') {
                        triggerClick(ev.domEvent, ev.target);
                    }
                    onItemTap($(ev.target), true);
                },
                onGestureStart: function (ev) {
                    trigger('onGestureStart', ev);
                },
                onGestureEnd: function (ev) {
                    trigger('onGestureEnd', ev);
                },
                onMove: function (ev) {
                    trigger('onMove', ev);
                },
                onAnimationStart: function (ev) {
                    trigger('onAnimationStart', ev);
                },
                onAnimationEnd: function (ev) {
                    trigger('onAnimationEnd', ev);
                }
            });
        } else {
            $cont.attr('class', contClass);
            // Remove ripple events (if theme changed)
            $elm.off('.mbsc-ripple');
        }

        // Prepare markup
        $elm.css('display', '').addClass('mbsc-scv').removeClass('mbsc-cloak');

        initMarkup();

        trigger('onMarkupReady', {
            target: $cont[0]
        });

        // ---

        size();

        // Attach events
        // ---

        // When images are loaded, size migth change
        $cont.find('img').on('load', onResize);

        $wnd.on('orientationchange resize', onResize);

        // ---
    };

    that._size = noop;
    that._initMarkup = noop;
    that._markupReady = noop;
    that._getContClass = noop;
    that._getItemProps = noop;
    that._getActiveItem = noop;
    that.__init = noop;
    that.__destroy = noop;

    /**
     * Destroy
     */
    that._destroy = function () {
        that.__destroy();
        $wnd.off('orientationchange resize', onResize);

        $elm.removeClass('mbsc-scv').insertAfter($cont).find('.mbsc-scv-item').each(function () {
            var $item = $(this);
            $item.width('').removeClass(cssClasses[$item.attr('data-ref')]);
        });

        $cont.remove();

        scrollView.destroy();
    };

    that._getItem = function (item) {
        if (typeof item !== 'object') {
            item = that._$items.filter('[data-id="' + item + '"]');
        }
        return $(item);
    };

    that._onItemTap = function ($item, toggle) {
        if (toggle === undefined) {
            return true;
        }
        return toggle;
    };

    // ---

    // Constructor

    s = that.settings;
    trigger = that.trigger;

    if (!inherit) {
        that.init(settings);
    }
};

// Defaults
ScrollView.prototype = {
    _class: 'scrollview',
    _hasDef: true,
    _hasTheme: true,
    _hasLang: true,
    _defaults: {
        tap: true,
        stopProp: false,
        context: 'body',
        layout: 'liquid'
    }
};

classes.ScrollView = ScrollView;



// WEBPACK FOOTER //
// ./src/js/lib/mobiscroll/classes/scrollview.js